import React from 'react';
import SchedulerComponent from '../../../SchedulerView/ScheduleItemDialog/SchedulerComponent/SchedulerComponent.tsx';
import {
    Autocomplete,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    IconButton,
    Paper,
    Switch,
    Tab,
    TextField,
} from '@mui/material'
import Typography from '@mui/material/Typography'
import Cancel from './../../../../../../assets/icons/close.png'
import itemImg from './../../../../../../assets/icons/schedule.png'
function InventoryScheduleDialog(props) {
    const handleClose = (data) => {
        props.onHandleAddItem(data)
    }
    return (
        <div>
            <React.Fragment>
                <Dialog
                    fullWidth={true}
                    maxWidth={'lg'}
                    open={props.open}
                    onClose={handleClose}
                >
                    <Grid container>
                        <Grid item xs={8}>
                            <DialogTitle>
                                <div className='d-flex' style={{ gap: "8px" }}>
                                    <div>
                                        <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
                                    </div>

                                    <span style={{ color: "#2a7fd4" }}>GoTaste :-  Create Schedule</span>
                                </div>
                            </DialogTitle>
                        </Grid>
                        <Grid item xs={4}>
                            <DialogActions>
                                <Button onClick={handleClose}>
                                    <img src={Cancel} alt="Close" style={{ width: '1.2rem' }} />
                                </Button>
                            </DialogActions>
                        </Grid>
                    </Grid>
                    <DialogContent style={{ backgroundColor: '#f3f0f3' }}>

                        <SchedulerComponent from="discount" setSchedule={handleClose}></SchedulerComponent>



                    </DialogContent>
                </Dialog>
            </React.Fragment>

        </div>
    );
}

export default InventoryScheduleDialog;